<div class="CP">
    <div class="CP__header">Please wait while we check the status...</div>
   <div class="CP__row" v-for="progress in registrationProgress" :key="progress.id">
        <div class="CP__description">{{ progress.description }}</div>
        <div class="CP__status">
            <span>{{ progress.status }}</span>
            <progress-spinner class="CP__spinner"
                v-if="progress.status === 'InProcess'">
            </progress-spinner>
            <mom-icon class="CP__pending" width="20" height="20"
                svgIcon="info" v-else-if="progress.status === 'Pending'" :key="progress.status"></mom-icon>
            <mom-icon class="CP__completed" width="20" height="20"
                svgIcon="checked-circle" v-else-if="progress.status === 'Completed'" :key="progress.status"></mom-icon>
            <mom-icon class="CP__failed" width="20" height="20"
                svgIcon="cross-circle" v-else-if="progress.status === 'Failed'" :key="progress.status"></mom-icon>
        </div>
   </div>
</div>